export interface ProductAlternative {
    descripcion: string;
    diferencia: number;
    diInv: string;
    existencias: number;
    existenciasFalso: string;
    horas: number;
    imagenArticulo: string;
    imagenMarca: string;
    marca: string;
    modelo: string;
    orden: number;
    preArt: string;
    precio: number;
    precioMostrarBusqueda: number;
    precioMostrarPedido: number;
    precioSinDescuento: number;
    preDto1: number;
    preDto2: number;
    preDto3: number;
    preDto4: number;
    preDto5: number;
    preIde: string;
    prePrm: number;
    tiempo: number;
    tipo: string
}

export class ProductAlternativeHelper {

    static create(): ProductAlternative {
        return {
            descripcion: '',
            diferencia: 0,
            diInv: '',
            existencias: 0,
            existenciasFalso: '',
            horas: 0,
            imagenArticulo: '',
            imagenMarca: '',
            marca: '',
            modelo: '',
            orden: 0,
            preArt: '',
            precio: 0,
            precioMostrarBusqueda: 0,
            precioMostrarPedido: 0,
            precioSinDescuento: 0,
            preDto1: 0,
            preDto2: 0,
            preDto3: 0,
            preDto4: 0,
            preDto5: 0,
            preIde: '',
            prePrm: 0,
            tiempo: 0,
            tipo: ''
        };
    }

    // static getTotal(info: ProductAlternative): number {
    //     return info.neto + info.ecoTax + info.tax;
    // }

    static transformFromApi(apiData: any, environment: any) {

        const alternativeProduct = ProductAlternativeHelper.create();

        alternativeProduct.descripcion = apiData['DESCRIPCION'] ? apiData['DESCRIPCION'] : '';
        alternativeProduct.diferencia = apiData['DIFERENCIA'] ? apiData['DIFERENCIA'] : 0;
        alternativeProduct.diInv = apiData['DIINV'] ? apiData['DIINV'] : '';
        alternativeProduct.existencias = apiData['EXISTENCIAS'] ? apiData['EXISTENCIAS'] : 0;
        alternativeProduct.existenciasFalso = apiData['EXISTENCIASFALSO'] ? apiData['EXISTENCIASFALSO'] : '';
        alternativeProduct.horas = apiData['HORAS'] ? apiData['HORAS'] : 0;

        
        alternativeProduct.imagenArticulo = apiData['IMAGEN_ARTICULO'] ? apiData['IMAGEN_ARTICULO'] : '';
        alternativeProduct.imagenMarca = apiData['IMAGEN_MARCA'] ? apiData['IMAGEN_MARCA'] : '';

        // Change url images
        if (alternativeProduct.imagenArticulo[0] === '~') { alternativeProduct.imagenArticulo = environment.url_prefix + alternativeProduct.imagenArticulo.substr(1); }
        if (alternativeProduct.imagenMarca[0] === '~') { alternativeProduct.imagenMarca = environment.url_prefix + alternativeProduct.imagenMarca.substr(1); }
        
        alternativeProduct.marca = apiData['MARCA'] ? apiData['MARCA'] : '';
        alternativeProduct.modelo = apiData['MODELO'] ? apiData['MODELO'] : '';
        alternativeProduct.orden = apiData['ORDEN'] ? apiData['ORDEN'] : 0;
        alternativeProduct.preArt = apiData['PREART'] ? apiData['PREART'] : '';
        alternativeProduct.precio = apiData['PRECIO'] ? apiData['PRECIO'] : 0;
        alternativeProduct.precioMostrarBusqueda = apiData['PRECIOMOSTRARBUSQUEDA'] ? apiData['PRECIOMOSTRARBUSQUEDA'] : 0;
        alternativeProduct.precioMostrarPedido = apiData['PRECIOMOSTRARPEDIDO'] ? apiData['PRECIOMOSTRARPEDIDO'] : 0;
        alternativeProduct.precioSinDescuento = apiData['PRECIOSINDESCUENTO'] ? apiData['PRECIOSINDESCUENTO'] : 0;
        alternativeProduct.preDto1 = apiData['PREDTO1'] ? apiData['PREDTO1'] : 0;
        alternativeProduct.preDto2 = apiData['PREDTO2'] ? apiData['PREDTO2'] : 0;
        alternativeProduct.preDto3 = apiData['PREDTO3'] ? apiData['PREDTO3'] : 0;
        alternativeProduct.preDto4 = apiData['PREDTO4'] ? apiData['PREDTO4'] : 0;
        alternativeProduct.preDto5 = apiData['PREDTO5'] ? apiData['PREDTO5'] : 0;
        alternativeProduct.preIde = apiData['PREIDE'] ? apiData['PREIDE'] : '';
        alternativeProduct.prePrm = apiData['PREPRM'] ? apiData['PREPRM'] : 0;
        alternativeProduct.tiempo = apiData['TIEMPO'] ? apiData['TIEMPO'] : 0;
        alternativeProduct.tipo = apiData['TIPO'] ? apiData['TIPO'] : '';

        return alternativeProduct;
    }
}
